import React from "react";

import Div from "@components/Div";
import ProgressSpinner from "@components/ProgressSpinner";

import { EmailThread } from "./components";
import { useEmailsTab } from "./EmailsTab.hooks";

const EmailsTab = () => {
  const { emailsData, isLoading } = useEmailsTab();

  return (
    <Div>
      {isLoading && <ProgressSpinner />}

      {emailsData.length > 0 && <EmailThread data={emailsData} />}
    </Div>
  );
};

export default EmailsTab;
